var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_c('app-header'),_c('router-view'),_vm._m(1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global app-loader"},[_c('div',{staticClass:"loader"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routeloader"},[_c('div',{staticClass:"loader"})])
}]

export { render, staticRenderFns }